import React, { useEffect, useState } from "react";
import { IoChevronBackSharp } from "react-icons/io5";
import axios from "axios";
import { API, sendNotfication } from "../../../Helper";
import Cookies from "js-cookie";

function UpiGetway({ isOpen, onClose, data }) {
  const [amount, setAmount] = useState("");
  const [currencyType, setCurrencyType] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [loading, setLoading] = useState(false);
  const [mininumAmount, setMinimumAmount] = useState(300);
  const [maximumAmount, setMaximumAmount] = useState(100000);

  useEffect(() => {
    if (data?.currency_code) {
      setCurrencyType(data?.currency_code);
    }
  }, [data]);

  useEffect(() => {
    setPaymentMethod("");
  }, [currencyType]);

  if (!isOpen || !data) return null;

  // ✅ Payment methods with images
  const PAYMENT_METHODS = {
    BDT: [
      { id: "bkash_api_v", name: "bKash Fast", img: "	https://dazen1.one/form/logo/bkash_b_ff94fd90c32c414cb04f5340ae3d7a8c.svg" },
      { id: "bkash_api_v", name: "bKash P2P", img: "https://dazen1.one/form/logo/bkash_p2p_74e5df7387da4948a6bda46f4a2e81e4.svg" },
      { id: "nagad_api_v", name: "Nagad Fast", img: "	https://dazen1.one/form/logo/nagad_b_9ceade309a1a437d9942ec7627c9a67e.svg" },
      { id: "upay", name: "UPay", img: "https://dazen1.one/form/logo/upay_60cdee9d297f4fee805878b43a0f11e1.svg" },

    ],
    NPR: [
      { id: "khalti_l", name: "Khalti", img: "https://dazen1.one/form/logo/khalti_l_e5e41267fd71456bb86b878b31b87bcf.webp" },
      {id:'esewa_p2p', name:'eSewa P2P', img:'/assets/esewa_logo.png'},

    ],
    PKR: [
      { id: "easypaisa", name: "Easypaisa", img: "https://dazen1.one/form/logo/easypaisa_2e3522b1476b48959b709aca9d73a320.svg" },
      // { id: "Easypaisa P2P", name: "Easypaisa P2P", img: "https://dazen1.one/form/logo/easypaisa_l_f23a3903cace4a4cb4c3188c601d2d95.svg" },
      { id: "jazzcash_fast", name: "Jazzcash Fast", img: "https://dazen1.one/form/logo/jazzcash_l_74a909ff3d474ab8a0ba4d21477d5478.svg" },
       { id: "nayapay_l", name: "Nayapay", img: "https://dazen1.one/form/logo/nayapay_l_f4150236bafe4dca89c915709dd5bdb6.svg" },
      { id: "Jazzcash P2P", name: "Jazzcash P2P", img: "https://dazen1.one/form/logo/jazzcash_l_74a909ff3d474ab8a0ba4d21477d5478.svg" }
    ],
    EGP: [
      { id: "egp_card", name: "EGP Card", img: "https://dazen1.one/form/logo/egp_card_45bd78684dfc41fc82e59f2777839470.svg" },
      { id: "EGP Wallet P2P", name: "EGP Wallet P2P", img: "https://dazen1.one/form/logo/egp_tel_ede4e9ad0c5c41e4b5574ae8efe8c620.svg" },
      { id: "EGP Wallet Fast", name: "EGP Wallet Fast", img: "	https://dazen1.one/form/logo/egp_tel_fast_86d8b19949624ae5a1e70de065862aad.svg" },
    ],
  };

  const handleGatewayDeposit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (window.fbq) {
      window.fbq('track', 'AddToCart');
    }

    let click_id = localStorage.getItem('click_id');


    try {
      const response = await axios.post(`${API}/payment/api/paynow/upi`, {
        money: parseFloat(amount),
        uid: parseFloat(Cookies.get("uid")),
        currencyType,
        paymentMethod,
        click_id,
      });

      const resData = response?.data;

      if (!resData || resData?.status === false) {
        sendNotfication(
          resData?.message || "Payment failed!",
          "danger",
          "bottom-left"
        );
        return;
      }

      if (resData?.urls?.web_url) {
        window.location.href = resData.urls.web_url;
      } else {
        sendNotfication("Payment URL missing!", "danger", "bottom-left");
      }
    } catch (error) {
      console.error(error);
      sendNotfication("Unexpected error!", "danger", "bottom-left");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="popup-overlay-inner-main-543">
      <div className="popup-container-inner-main-543">
        {/* <div className="vip2-popup-page" style={{ background: "#323738" }}>
          <div className="vip2-popup-page-btn" onClick={onClose}>
            <IoChevronBackSharp />
          </div>
          Deposit Method
        </div> */}

        <div
          style={{
            padding: "20px",
            background: "#232626",
            borderRadius: "0 0 10px 10px",
          }}
        >
          {/* Currency */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: 8 }}>Deposit Currency</div>
            <select
              value={currencyType}
              onChange={(e) => setCurrencyType(e.target.value)}
              style={{
                background: "#323738",
                color: "#fff",
                padding: "8px 12px",
                borderRadius: 8,
                border: "1px solid #444",
              }}
            >
              <option value="BDT">BDT</option>
              <option value="PKR">PKR</option>
              <option value="EGP">EGP</option>
              <option value="NPR">NPR</option>
            </select>
          </div>

          {/* Payment methods */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: 10 }}>Select Payment Method</div>

            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              {(PAYMENT_METHODS[currencyType] || []).map((method) => (
                <div
                  key={method.id}
                  onClick={() => setPaymentMethod(method.id)}
                  style={{
                    width: 120,
                    padding: 10,
                    borderRadius: 10,
                    border:
                      paymentMethod === method.id
                        ? "2px solid #FF9820"
                        : "1px solid #444",
                    background: "#323738",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                >
                  <img
                    src={method.img}
                    alt={method.name}
                    style={{ width: 60, marginBottom: 8 }}
                  />
                  <div style={{ fontSize: 12 }}>{method.name}</div>
                </div>
              ))}
            </div>
          </div>

          {!paymentMethod && (
            <div style={{ opacity: 0.7, marginTop: 10 }}>
              Please select a payment method to continue
            </div>
          )}

          {/* Amount */}
          {/* Amount + Submit — show only after payment method selected */}
          {paymentMethod && (
            <div>
              {/* in number Specify payment limit from 300 - 100000  and remove up down arrow*/}
              <input
                type="number"
                placeholder="Enter Amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                style={{
                  width: "100%",
                  padding: 10,
                  borderRadius: 8,
                  border: "1px solid #444",
                  background: "#323738",
                  color: "#fff",
                }}
                min="300"
                max="100000"
                  onWheel={(e) => e.target.blur()}

              />
              <span style={{ fontSize: 12, opacity: 0.7, color: "#B3BEC1" }}>
                Minimum: 300, Maximum: 100000
              </span>

              <button
                onClick={handleGatewayDeposit}
                disabled={!amount || loading || parseFloat(amount) < mininumAmount || parseFloat(amount) > maximumAmount}
                style={{
                  marginTop: 15,
                  width: "100%",
                  padding: 12,
                  borderRadius: 8,
                  background: "#FF9820",
                  border: "none",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          )}
          <div
            className="deposit-rules-text-12"
            style={{
              background: "#314940",
              color: "#B3BEC1",
            }}
          >
            <div>
              1. Your transfer amount has to MATCH the submission amount.
            </div>
            <div>
              2. Each Order ID can ONLY be used once to avoid duplicates.
            </div>{" "}
            <div>
              3. Please follow the deposit guideline to make deposit,
              otherwise your deposit will be missing.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpiGetway;
